module.exports = __webpack_public_path__ + "img/HG4102-74.b17f88e4.jpg";